import { surveyFormsService } from "../../../../../Api/Services/SurveyFormsService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { ICreateSurveyFormQuestionPayload } from "../../../../../Types/SurveyFormsTypes";
import { IStatusRepsonse } from "../../../../../Types/UserProfileDetails";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

export interface ISurveyFormQuestionsAddArgs {
  form_id: number;
  payload: ICreateSurveyFormQuestionPayload;
}

export const addSurveyFormQuestionThunk = createServiceAsyncThunk<
  IStatusRepsonse,
  ISurveyFormQuestionsAddArgs
>(
  ACTION_NAMES.ADD_SURVEY_FORM_QUESTION,
  ({ form_id, payload }) =>
    surveyFormsService.submitSurveyFormQuestion(form_id, payload),
  ERROR_MESSAGES.SURVEY_FORM_QUESTION_ADD_FAILURE
);

const surveyFormQuestionAddSlice = createGenericSlice<
  IStatusRepsonse,
  ISurveyFormQuestionsAddArgs
>(SLICE_NAMES.SURVEY_FORM_QUESTION_ADD, addSurveyFormQuestionThunk);

export const {
  clearError: clearSurveyFormQuestionAddError,
  clearSuccessMessage: clearSurveyFormQuestionAddSuccess,
} = surveyFormQuestionAddSlice.actions;

export default surveyFormQuestionAddSlice.reducer;
